export default __webpack_public_path__ + "static/Plots0093-548bb4aba534d12971fe5411fe5b844d.jpg";